import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationVehicleScreens,
  simulationVehicleFinancingScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Financiamento de Veículo no caminho do legado (`router.tsx:1108-1122`, `vehicleProductCategory = 2`): o passo vai em
// `?passo=`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/veiculo/financiamento/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationVehicleFinancingScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationVehicleScreens, 'VehicleFinancingRouteScreen'),
});
